import { render, staticRenderFns } from "./RevaluationQueue.vue?vue&type=template&id=0b76955a&scoped=true"
import script from "./RevaluationQueue.vue?vue&type=script&lang=ts"
export * from "./RevaluationQueue.vue?vue&type=script&lang=ts"
import style0 from "./RevaluationQueue.vue?vue&type=style&index=0&id=0b76955a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76955a",
  null
  
)

export default component.exports